<template><svg version="1.0" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
<g transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)">
<path d="M445 5110 c-194 -40 -352 -179 -417 -368 l-23 -67 0 -2115 0 -2115
23 -66 c57 -166 185 -294 350 -351 l67 -23 1505 0 1505 0 67 23 c164 57 287
179 350 348 22 57 22 73 26 495 l3 436 51 24 c27 13 76 40 107 61 l56 37 385
-383 c212 -211 395 -389 407 -395 31 -16 99 -14 133 4 38 20 68 60 76 100 14
78 15 77 -398 492 l-391 391 47 75 c106 170 156 349 156 557 0 282 -94 520
-284 718 -96 100 -168 156 -270 208 l-76 39 0 383 c0 331 -2 387 -16 415 -22
44 -1020 1044 -1066 1068 -36 18 -69 19 -1185 18 -631 -1 -1166 -5 -1188 -9z
m2155 -730 c0 -422 1 -442 20 -480 13 -26 34 -47 60 -60 38 -19 58 -20 480
-20 l440 0 0 -252 0 -253 -138 -1 c-113 -1 -154 -6 -237 -28 -184 -48 -326
-129 -468 -266 -138 -132 -225 -275 -284 -467 -25 -83 -27 -100 -27 -283 0
-183 2 -200 27 -283 59 -192 146 -335 284 -467 142 -137 284 -218 468 -266 83
-22 124 -27 237 -28 l138 -1 0 -356 c0 -405 -3 -422 -75 -494 -80 -81 39 -75
-1575 -75 -1614 0 -1495 -6 -1575 75 -82 81 -75 -112 -75 2185 0 2298 -7 2104
75 2185 77 78 5 73 1178 74 l1047 1 0 -440z m545 -20 l240 -240 -243 0 -242 0
0 240 c0 132 1 240 3 240 1 0 110 -108 242 -240z m479 -1354 c151 -29 272 -94
387 -206 86 -85 145 -178 186 -295 26 -74 28 -91 28 -235 0 -144 -2 -161 -28
-235 -41 -117 -100 -210 -186 -295 -182 -179 -420 -252 -665 -206 -151 29
-272 94 -387 206 -86 85 -145 178 -186 295 -26 74 -28 91 -28 235 0 144 2 161
28 235 126 361 483 571 851 501z"/>
<path d="M678 3499 c-43 -22 -78 -81 -78 -129 0 -50 35 -107 80 -130 38 -20
57 -20 920 -20 863 0 882 0 920 20 45 23 80 80 80 130 0 50 -35 107 -80 130
-38 20 -57 20 -922 20 -859 -1 -884 -1 -920 -21z"/>
<path d="M678 2899 c-43 -22 -78 -81 -78 -129 0 -50 35 -107 80 -130 38 -19
57 -20 720 -20 663 0 682 1 720 20 45 23 80 80 80 130 0 50 -35 107 -80 130
-38 19 -57 20 -722 20 -660 -1 -684 -2 -720 -21z"/>
<path d="M678 2299 c-43 -22 -78 -81 -78 -129 0 -50 35 -107 80 -130 38 -19
57 -20 720 -20 663 0 682 1 720 20 45 23 80 80 80 130 0 50 -35 107 -80 130
-38 19 -57 20 -722 20 -660 -1 -684 -2 -720 -21z"/>
<path d="M678 1699 c-43 -22 -78 -81 -78 -129 0 -50 35 -107 80 -130 38 -19
57 -20 720 -20 663 0 682 1 720 20 45 23 80 80 80 130 0 50 -35 107 -80 130
-38 19 -57 20 -722 20 -660 -1 -684 -2 -720 -21z"/>
</g>
</svg>
</template>